export const YES_NO_OPTIONS = [
  { id: true, title: 'Yes' },
  { id: false, title: 'No' },
]
export const TRUE_FALSE_OPTIONS = [
  { id: true, title: 'True' },
  { id: false, title: 'False' },
]
